import React, { forwardRef } from "react";

const COE = forwardRef(({ data }, ref) => {
  if (!data) return null;
  const t = data.template;

  return (
    <div ref={ref} className="printable" style={{ fontFamily: '"Times New Roman", serif', fontSize: "12pt", lineHeight: 1.5, color: "black" }}>

      {/* ── Header ── */}
      {t.letterheadUrl ? (
        <div style={{ marginBottom: 20 }}>
          <img src={t.letterheadUrl} alt="Letterhead" style={{ width: "100%", display: "block" }} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 20 }}>
          {t.logoUrl && (
            <img src={t.logoUrl} alt="Logo" style={{ height: 52, width: "auto", objectFit: "contain", flexShrink: 0 }} />
          )}
          <div>
            {/* Agency line */}
            <div style={{ fontWeight: "bold", fontSize: "13pt" }}>GOLDEN GATEWAY INTERNATIONAL AGENCY</div>
            <div style={{ fontSize: "11pt" }}>Don Gil Garcia Street, Capitol Site, Cebu City</div>
            {t.dtiCert && (
              <div style={{ fontSize: "11pt", fontStyle: "italic", color: "#333" }}>
                DTI Certificate No. {t.dtiCert}
              </div>
            )}
            {/* Employer company */}
            <div style={{ fontWeight: "bold", fontSize: "12pt", marginTop: 6 }}>{t.company}</div>
            {t.issueCity && <div style={{ fontSize: "11pt" }}>{t.issueCity}</div>}
          </div>
        </div>
      )}

      <div style={{ textAlign: "right", fontSize: "11pt", marginBottom: 20 }}>
        Certificate No.: {data.certificateNo}
      </div>

      <h2 style={{ fontFamily: '"Times New Roman", serif', textAlign: "center", textDecoration: "underline", fontSize: "16pt", margin: "48px 0 48px", fontWeight: "bold" }}>
        CERTIFICATE OF EMPLOYMENT
      </h2>

      <p style={{ fontWeight: "bold", marginBottom: 20 }}>TO WHOM IT MAY CONCERN:</p>

      <p style={{ textAlign: "justify", marginBottom: 14, textIndent: "0.5in" }}>
        This is to certify that <strong>{data.titledName}</strong> has been employed with <strong>{t.company}</strong> from <strong>{data.startDateFormatted} to Present</strong> as a {t.longRole}.
      </p>

      <p style={{ textAlign: "justify", marginBottom: 14, textIndent: "0.5in" }}>
        {data.pronoun.poss.charAt(0).toUpperCase() + data.pronoun.poss.slice(1)} duties and responsibilities include {t.coeDuties}.
      </p>

      <p style={{ textAlign: "justify", marginBottom: 14, textIndent: "0.5in" }}>
        Throughout {data.pronoun.poss} employment, {data.titledLast} has consistently demonstrated dedication, reliability, and competence in performing {data.pronoun.poss} assigned tasks. As of this date, {data.pronoun.subj.toLowerCase()} has rendered <strong>{data.yearsWord} ({data.yearsService}) year{data.yearsService === 1 ? "" : "s"} and {data.monthsWord} ({data.monthsService}) month{data.monthsService === 1 ? "" : "s"}</strong> of continuous and faithful service to the company.
      </p>

      <p style={{ textAlign: "justify", marginBottom: 30, textIndent: "0.5in" }}>
        This certification is issued upon {data.pronoun.poss} request for any legal or official purpose it may serve.
      </p>

      <p style={{ marginBottom: 50 }}>
        Issued this {data.coeIssueDateOrdinal}, at {t.issueCity}.
      </p>

      {/* Signature block — centered */}
      <div style={{ textAlign: "center" }}>
        {t.signatureUrl && (
          <img src={t.signatureUrl} alt="Signature" style={{ height: 48, width: "auto", display: "block", margin: "0 auto 4px" }} />
        )}
        <p style={{ fontWeight: "bold", marginBottom: 0 }}>{t.manager}</p>
        <p style={{ margin: 0 }}>Manager</p>
        <p style={{ margin: 0, fontSize: "11pt" }}>{t.company}</p>
      </div>
    </div>
  );
});

export default COE;
